import { createSelector } from 'reselect';
import { IState } from '../createStore';

const selectCasinoSchema = (state: IState) => state.app.persistedState.casinoSchema;

export const selectCasinoId = createSelector(
  [selectCasinoSchema],
  (casinoSchema) => casinoSchema?.casinoId
);
